import Vue from "vue"
import { Component, Prop, Emit } from "vue-property-decorator"
import { IContractSettings } from "../../new-contract-vuex-store";
import ValidatedFormGroup from "../../Default/common/validated-form-group.vue"
import PreProductSelectionDisplay from "../steps/pre-product-selection-display.vue"
import ProductSelectionDisplay from "../steps/product-selection-display.vue"
import MoveOutMeteringPointInformationDisplay from "../steps/move-out-metering-point-information-display.vue"
import SessionExpiration from "../../Default/common/session-expiration.vue";
import { IProductGroupViewModel, IContractViewModel, IAddressViewModel, ICustomerViewModel, ICompanyViewModel } from "../../../../../Scripts/inpulse/I4UViewModels";
import { AddressFormat } from "../../../../../Scripts/inpulse/AddressFormat";
import { UtilityTypeFormat, ContractTypeFormat, CommonFormatUtils, GenericTypeFormatTranslator } from "../../../../../Scripts/inpulse/FormatUtils";
import { ProcessTypeEnum, CustomerTypeEnum, UtilityTypeEnum, ContractTypeEnum } from "../../../../../Scripts/inpulse/CommonEnums";
import * as moment from "moment-recent";
import { TranslateResult } from "vue-i18n"
import LoadingComponent from "@/Scripts/vue-components/common/loading.vue";

declare let currentLocale: string;
declare let customerCultureCode: string;

@Component({
    components: {
        ValidatedFormGroup,
        PreProductSelectionDisplay,
        ProductSelectionDisplay,
        MoveOutMeteringPointInformationDisplay,
        SessionExpiration,
        LoadingIndicator: LoadingComponent
    },
    filters: {
        date(value) {
            let m = moment(value);
            if (m.isValid())
                return m.format("DD.MM.YYYY");
            return value;
        }
    }
})

export default class PhaseMoveOutConfirmation extends Vue {
    get contractSettings(): IContractSettings { return this.$store.state.contractSettings; }
    get isLoading(): boolean { return this.$store.state.loadingNewPhase }
    get contract(): IContractViewModel { return this.$store.state.contract; }
    get customer(): ICustomerViewModel { return this.contract.Customer; }
    get company(): ICompanyViewModel { return this.contract.Company; }
    get customerName(): string { return this.$store.getters.customerName; }
    get customerIdentifier(): string { return this.$store.getters.customerIdentifier; }
    get customerPhone(): string { return this.$store.getters.customerPhone; }
    get customerEmail(): string { return this.$store.getters.customerEmail; }
    get customerAddress(): IAddressViewModel { return this.$store.getters.customerAddress; }
    get hasNewContract(): boolean { return this.$store.state.contract.ProcessType == ProcessTypeEnum.MOVINGPROCESS }
    get isConsumerContract(): boolean { return this.$store.state.contract.CustomerType == CustomerTypeEnum.CONSUMER }
    get isCompanyContract(): boolean { return this.$store.state.contract.CustomerType == CustomerTypeEnum.COMPANY }
    //get selectedProductGroups(): IProductGroupViewModel[] { return this.$store.state.selectedProduct.ProductGroups; }    

    get finalInvoicingAddress(): string {
        return AddressFormat.toSingleString(this.contract.MoveOutProcess.FinalInvoicingAddress.Address, { coName: true });
    }

    CustomerTypeEnum: typeof CustomerTypeEnum = CustomerTypeEnum;

    @Prop()
    public validationErrors: any;

    @Prop()
    public currentLocale: string;

    @Emit()
    public previousPhase() { }

    constructor() {
        super();
    }

    mounted() {
        if (this.$store.state.contract.CustomerContracts.length < 1) {
            console.log("istunto vanhentunut");
            this.$root.$emit("notifySessionException", true);
        }

        this.setCultureCode();
    }

    get customerAddressString() {
        return AddressFormat.toSingleString(this.customerAddress);
    }

    get meteringPointAddressString() {
        const addr = this.contract.MeteringPoint.Address;
        return AddressFormat.toSingleString(addr);
    }

    utilityTypeString(type: UtilityTypeEnum): string | TranslateResult {
        return GenericTypeFormatTranslator.toString(UtilityTypeFormat.toString, type, this.$i18n);
    }

    contractTypeString(type: ContractTypeEnum): string | TranslateResult {
        return GenericTypeFormatTranslator.toString(ContractTypeFormat.toString, type, this.$i18n);
    }

    confirm() {
        console.log("Confirm!");
    }

    formatDate(date: string) {
        return CommonFormatUtils.formatDate(date);
    }

    join(separator: string, strs: string[]) {
        const arr = [];
        strs.forEach(s => {
            if (s != null && s.length != 0)
                arr.push(s);
        });
        return arr.join(separator);
    }

    formatPostal(postalCode: string, postOffice: string) {
        const str = this.join(", ", [postalCode, postOffice]);
        return str;
    }

    setCultureCode(): void {
        let cultureCode = "fi-FI";
        if (customerCultureCode == "" && currentLocale !== null && currentLocale !== "") {
            if (currentLocale.startsWith("fi")) {
                cultureCode = "fi-FI";
            }
            if (currentLocale.startsWith("sv")) {
                cultureCode = "sv-SE";
            }
        }
        else {
            cultureCode = customerCultureCode;
        }
        let langKey = "language-selection";
        if (this.contract.CustomerType == CustomerTypeEnum.COMPANY)
            langKey = "companylanguage-selection";
        new Promise<void>((resolve, reject) => {
            this.$store.dispatch("changeValue", { key: langKey, value: cultureCode }).then(res => resolve())
        });
    }

    isPriimaPlus(): boolean {
        return this.contractSettings.PriimaPlusProductId && this.contractSettings.PriimaPlusProductId > 0
            && this.contract.ProductId == this.contractSettings.PriimaPlusProductId;
    }
}